module.exports = __webpack_public_path__ + "img/img_abs.a7de0bca.png";